<style scoped>

</style>
<template>
  <span>
    {{ name }}
  </span>
</template>
<script>
  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
      short: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      companies_hash() {
        return this.$store.getters['async/companies_hash'];
      },
      name() {
        const company = this.companies_hash[this.id];
        if (company && this.short) return company.short_name;
        return company ? company.name : '-';
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
